import axios from 'axios'
import router from '../router'
import { Message } from "element-ui";

const Service = axios.create({
    baseURL:process.env.VUE_APP_BASE_API,
    timeout: 20 * 1000
})
Service.interceptors.request.use(config => {
    if(window.localStorage.getItem('token')) {
        config.headers.Authorization  = 'Bearer ' + window.localStorage.getItem('token')
    }
    return config
}, err => {
    Promise.reject(err)
})


Service.interceptors.response.use(response => {
    if(response.data.code == 200){
        return response.data
    } else if(response.data.code == 202){
        router.push({
            path: '/login'})
    }else if(response.data.code == 201){
        Message({
            message: response.data.message || '請求異常，請聯繫管理員處理！',
            type: 'warning',
            duration: 5 * 1000
        })
        return
    }

}, err => {
    Promise.reject(err)
})

export default Service
